import styled from "styled-components";

export const Container = styled.div`
  width: 430px;
  height: 60px;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

`;

export const Wrap = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex: 1;
`;

export const Content = styled.div<{execucion?: boolean}>`
    width: 100%;
    max-height: calc(-140px + 100vh);
    
    ${props => props.execucion ? `
        max-height: calc(-140px + 100vh);
        overflow-y: auto;
    ` : `
        height: 86vh;
    `}
    
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    justify-content: space-between;

    position: absolute;
    margin-top: 0.75rem;
    border-radius: 8px;
`;

export const ContentDetailFooter = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    padding: 8px 18px;
    border-top: 1px solid #84848440;
    justify-content: space-between;
     @media print { // Adicionado temporariamente
        display: none;
    }
`;

export const GridButton = styled.button`
    background: #f5f5f5;
    color: #757575;
    border: 1px solid #e0e0e0;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.2s ease;
    width: 80%;
`;